var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup345(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20711 7C0.761654 7 0.538571 7.53857 0.853553 7.85355L5.14645 12.1464C5.34171 12.3417 5.65829 12.3417 5.85355 12.1464L10.1464 7.85355C10.4614 7.53857 10.2383 7 9.79289 7H1.20711Z",
    fill: "#ACB8C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79289 5.5C10.2383 5.5 10.4614 4.96143 10.1464 4.64645L5.85355 0.353554C5.65829 0.158292 5.34171 0.158292 5.14645 0.353554L0.853554 4.64645C0.538571 4.96143 0.761654 5.5 1.20711 5.5L9.79289 5.5Z",
    fill: "#ACB8C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup345);
export default __webpack_public_path__ + "static/media/Group_345.fc976ae913ad7eb477a969f45565424d.svg";
export { ForwardRef as ReactComponent };